/* eslint-disable no-use-before-define */
import { gql } from "@apollo/client";

export const GET_PAYMENT_URL = gql`
  query getPaymentUrl {
    getPaymentUrl
  }
`;
